import { Capacitor, registerPlugin } from '@capacitor/core'
const Headwind = registerPlugin('Headwind')

const API_KEY = 'Lt4EUZaSmieU3UQ3JeGxmeCzL3xZzHRc'

export const requestAppUpdate = async () => {
  try {
    if (!Capacitor.isPluginAvailable('Headwind')) return false
    await Headwind.forceConfigUpdate()
  } catch (_) {
    return false
  }
}

export const isDeviceManaged = async () => {
  try {
    if (!Capacitor.isPluginAvailable('Headwind')) return false
    const { connected } = await Headwind.connect()
    return Boolean(connected)
  } catch (_) {
    return false
  }
}

export const getIMEI = async () => {
  try {
    if (!await isDeviceManaged()) return null
    const { value } = await Headwind.getConfig({ key: 'IMEI', apiKey: API_KEY })
    return value || null
  } catch (_) {
    return null
  }
}

export const getDeviceIDs = async () => {
  try {
    if (!await isDeviceManaged()) return null
    const [imei, iccid, serial] = await Promise.all([
      Headwind.getConfig({ key: 'IMEI', apiKey: API_KEY }).then(({ value }) => value || null),
      Headwind.getConfig({ key: 'ICCID', apiKey: API_KEY }).then(({ value }) => value ? `${value}`.slice(0, 19) : null),
      Headwind.getConfig({ key: 'SERIAL', apiKey: API_KEY }).then(({ value }) => value || null)
    ])
    return { imei, iccid, serial }
  } catch (_) {
    return null
  }
}
